<template>
  <b-container v-if="stackList && stackList.length" class="px-0" fluid>
    <div class="carousel-bg-image carousel-content w-100">
      <b-container class="text__stack-title w-100 p-0">
        <h5 class="font-weight-bold">Skill set packages</h5>
        <p>Unlock your full potential by mastering a powerful combination of skills</p>
      </b-container>
      <b-container class="p-0">
        <stack-carousel :stack-list="stackList" />
      </b-container>
    </div>
  </b-container>
</template>

<script>
import StackCarousel from './StackCarousel.vue';
import StackBackgroundPng from '@/assets/stack-background.png';
import Stack from '@/models/Stack';

export default {
  name: 'StackCarouselIndex',
  components: {
    StackCarousel
  },

  data() {
    return {
      StackBackgroundPng,
      stackList: []
    };
  },
  created() {
    this.getStacks();
  },

  methods: {
    async getStacks() {
      // Fetch stacks from the API
      try {
        const {
          response: {
            data: { items }
          }
        } = await Stack.api().findStackExplore();

        this.stackList = items;
      } catch (error) {
        console.error('Error fetching stacks:', error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel-bg-image {
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/stack-background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.carousel-content {
  padding: 32px 16px;
}

@media screen and (min-width: 768px) {
  .carousel-content {
    padding: 64px 32px;
  }

  .text__stack-title {
    h5 {
      font-size: 32px;
    }
    p {
      font-size: 20px;
    }
  }
}

@media screen and (min-width: 1200px) {
  .carousel-content {
    padding: 64px 0;
  }
}
</style>
